import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { MoviesService, Tag_Type } from 'src/app/core/services/movies.service';

@Component({
  selector: 'app-tag-search',
  templateUrl: './tag-search.component.html',
  styleUrls: ['./tag-search.component.css']
})
export class TagSearchComponent implements OnInit {
  movies: MovieModel[] = [];

  loading: boolean = false;

  @Input() currentTagType: Tag_Type;
  @Input() currentSearchQuerry: string;

  labelInput: string;

  constructor(private moviesService: MoviesService, private router: Router, private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.currentTagType = parseInt(this.activatedRoute.snapshot.params.tag);
    this.currentSearchQuerry = this.activatedRoute.snapshot.params.criteria;
    this.prepareLabel();
    this.SearchTag();
  }

  prepareLabel() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.label) {
        this.labelInput = params.label;
      }
    });
  }

  SearchTag() { //Aca se busca la tag que corresponda y se traen las pelis
    this.loading = true;
    this.moviesService.getMoviesByTag(this.currentTagType, this.currentSearchQuerry).subscribe((resp) => {
      this.movies = resp;
      this.loading = false;
    })
  }

  public get tag_type(): typeof Tag_Type {
    return Tag_Type;
  }

}
